export default "__VITE_ASSET__D7K7PghA__"